import { Component, Inject, OnInit } from '@angular/core';

import { EventService } from 'src/app/services/event.service';
import { SolarService } from 'src/app/services/cadastre-solaire/cadastre-solaire.service';
import { UsefulService } from 'src/app/services/UsefulService';
import { SolarPvTotalityService } from 'src/app/services/cadastre-solaire/cadastre-solaire-pv-totality.service';
import { SolarPvSurplusService } from 'src/app/services/cadastre-solaire/cadastre-solaire-pv-surplus.service';
import { SolarThermalService } from 'src/app/services/cadastre-solaire/cadastre-solaire-thermal.service';

@Component({
    selector: 'cadastreSolaireTechnology',
    templateUrl: './cadastre-solaire-technology.template.html',
    styleUrls: ['./cadastre-solaire-technology.component.scss'],
    standalone: false,
})
export class CadastreSolaireTechnologyComponent implements OnInit {
    public activeTabId: number = 1;
    public ui: string = 'desktop';

    constructor(
        @Inject(EventService) private eventService: EventService,
        @Inject(SolarService) public solarService: SolarService,
        @Inject(UsefulService) private usefulService: UsefulService,
        @Inject(SolarPvTotalityService) private solarPvTotalityService: SolarPvTotalityService,
        @Inject(SolarPvSurplusService) private solarPvSurplusService: SolarPvSurplusService,
        @Inject(SolarThermalService) public solarThermalService: SolarThermalService,
    ) {
        this.activeTabId = this.solarService.technology == 'pv' ? 1 : 2;
    }

    ngOnInit(): void {
        this.ui = this.usefulService.showMobileUi ? 'mobile' : 'desktop';
    }

    setTechnology(technology: string) {
        this.solarService.technology = technology;
        this.activeTabId = technology == 'pv' ? 1 : 2;
    }

    async validate() {
        await this._getCustomTerritoryInfo();

        const isThermal = this.solarService.technology === 'thermal';
        const stage = isThermal ? 'thermalStage' : 'pvStage';
        this.solarService.updateMainStage(stage);
    }

    cancel() {
        const stage = this.solarService.results.length ? 'resultsStage' : 'profileStage';
        this.solarService.updateMainStage(stage);
    }

    private async _getCustomTerritoryInfo() {
        // const isDifferentTerritory = this.solarService.isDifferentTerritory();
        // if (!isDifferentTerritory) {
        //     return;
        // }

        try {
            const customInfo = await this.solarService.getSolarCustomTerritoryInfo();
            this._setCustomInfo(customInfo);
        } catch (error) {
            console.error('Error _getCustomTerritoryInfo', error);
            this.solarService.selectionInfo.showLoader = false;
            // this.showLoader = false;
            // this.solarService.customInfo = undefined;
            // this.plotCadastreSolaireIndicatorService.selectedExistingElementsGroup.clearLayers();
            // this.plotCadastreSolaireIndicatorService.selectedNewElementsGroup.clearLayers();
            // this.solarService.updateMainStage(null);
            // this.moduleService.closeModule('solar');
            // this.notification.error(
            //     "Une erreur est survenue. Impossible d'initialiser les paramètres.",
            // );
            throw error;
        }
    }

    private _setCustomInfo(customInfo: any) {
        // this.customInfo = customInfo;
        this.solarService.customInfo = customInfo;

        // this.pvModuleArea = customInfo.pv.parameter.surface_module;

        this.solarService.moduleInfo = customInfo.module;
        this.solarService.contactsInfo = customInfo.contacts;

        if (this.solarService.technology === 'pv') {
            this.solarPvTotalityService.setPvInfo(customInfo.pv);
            this.solarPvSurplusService.setPvInfo(customInfo.pv);
        }
        if (this.solarService.technology === 'thermal') {
            this.solarThermalService.setThInfo(customInfo.th);
        }
    }
}
